import { VersionStatus } from "@app/models/VersionStatus";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";

@Injectable()
export class VersionApi extends HOAApiBase {

    constructor() {
        super('VersionApi');
    }

    /**
     * Check the passed version status
     * Returns a list of supported versions
     * @param version Local version of the app
     */
    public versionStatusGet(version: string): Observable<VersionStatus> {
        return this.http.get<VersionStatus>(this.createUrl("HOAPass", `/versions/${version}/status`));
    }
}

